import { render, staticRenderFns } from "./AdvisersFinder.vue?vue&type=template&id=667d2365&scoped=true&"
import script from "./AdvisersFinder.vue?vue&type=script&lang=js&"
export * from "./AdvisersFinder.vue?vue&type=script&lang=js&"
import style0 from "./AdvisersFinder.vue?vue&type=style&index=0&id=667d2365&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667d2365",
  null
  
)

export default component.exports